module.exports = __webpack_public_path__ + "646474e48f4c1ea783f43ac5e41fd111.woff2";


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles/fonts/lato/lato-bold-webfont.woff2
 ** module id = ./src/styles/fonts/lato/lato-bold-webfont.woff2
 ** module chunks = 0
 **/